import { observable } from 'mobx';
import type { MarginResponseArgs } from '../margin2';
import Margin, { convertMarginResponseToArgs } from '../margin2';

export type OrderItemPriceResponseArgs = {
  id: number;
  price: number;
  margin?: MarginResponseArgs;
  flight_price_change_detail?: string;
  budget_frame_amount?: number;
};

export type OrderItemPriceArgs = {
  id: number;
  price: number;
  margin?: Margin;
  showFee: boolean;
  flightPriceChangeDetail?: string;
  budgetFrameAmount?: number;
};

export const convertOrderItemPriceResponseToArgs = (response: OrderItemPriceResponseArgs, showFee: boolean) => {
  const args: OrderItemPriceArgs = {
    id: response.id,
    price: response.price,
    margin: response.margin ? new Margin(convertMarginResponseToArgs(response.margin)) : undefined,
    showFee,
    flightPriceChangeDetail: response.flight_price_change_detail,
    budgetFrameAmount: response.budget_frame_amount
  };
  return args;
};

export default class OrderItemPrice {
  @observable id: number;
  @observable price: number;
  @observable margin?: Margin;
  @observable showFee: boolean;
  @observable flightPriceChangeDetail?: string;
  @observable budgetFrameAmount: number;

  constructor(args: OrderItemPriceArgs) {
    this.id = args.id;
    this.price = args.price;
    this.margin = args.margin;
    this.showFee = args.showFee;
    this.flightPriceChangeDetail = args.flightPriceChangeDetail;
    this.budgetFrameAmount = args.budgetFrameAmount || args.price;
  }

  get totalPrice() {
    let p = this.price;
    if (this.showFee && this.margin) {
      p += this.margin.amount;
    }
    return p;
  }

  get totalPriceWithMargin() {
    let p = this.price;
    if (this.margin) {
      p += this.margin.amount;
    }
    return p;
  }
}
